import styled from 'styled-components';
import bookmarkIcon from '../../assets/bookmark.svg';
import codeIcon from '../../assets/code.svg';
import heartIcon from '../../assets/heart.svg';
import { Flex } from '../../utilities/GlobalStyle';
import { devices } from '../../utilities/responsive';

export const VacancyHeader = styled(Flex)`
    padding: 120px 0;
    margin-top: -64px;
    width: 100%;
    background: #F7FAFC;

    @media ${devices.tabletPortrait} {
        padding: 96px 0;
    }

    @media ${devices.phoneLg} {
        padding: 48px 0;
    }

    svg {
        width: 24px;
        height: 24px;
        margin-right: 16px;

        @media ${devices.phoneSm} {
            margin-right: 0;
        }
    }
`;

export const VacancyHeaderWrapper = styled.div`
    width: 50%;

    @media ${devices.tabletLandscape} {
        width: 100%;

        h1 {
            line-height: 1.2;
        }
    }

    @media ${devices.phoneSm} {
        text-align: center;
    }
`;

export const VacancyHeaderDetails = styled(Flex)`
    margin: 32px 0;

    @media ${devices.phoneSm} {
        flex-direction: column;
    }

    & > * {
        margin-right: 48px;

        @media ${devices.phoneLg} {
            margin-bottom: 32px;
        }

        @media ${devices.phone} {
            margin-right: 32px;
        }

        @media ${devices.phoneSm} {
            flex-direction: column;
            margin-right: 0;

            h1 {
                margin-top: 8px;
            }
        }
    } 
`;

export const VacancyDetailsWrapper = styled.div`
    margin-bottom: 240px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: flex-start;

    @media ${devices.desktopLg} {
        margin-bottom: 200px;
    }

    @media ${devices.tabletLandscape} {
        grid-template-columns: 1fr;
        margin-bottom: 0;
    }
`;

export const VacancyDetails = styled.div`
    h2 {
        display: inline-flex; 
        align-items: center;

        &::before {
            content: ' ';
            display: block;
            width: 24px;
            height: 24px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            margin-right: 16px;
            
        }

        &:nth-of-type(1) {
            &::before {
                background-image: url(${bookmarkIcon});
            }
        }

        &:nth-of-type(2) {
            &::before {
                width: 28px;
                height: 28px;
                background-image: url(${codeIcon});
            }
        }

        &:nth-of-type(3) {
            &::before {
                background-image: url(${heartIcon});
            }
        }
    }

    ul {
        margin-left: 8px;
        list-style: none;

        li {
            text-indent: -16px;
            
            &:not(:last-child) {
                margin-bottom: 4px;
            }

            &::before {
                content: "•  ";
                color: var(--primary);
            }
        }
    }

    h2 {
        font-size: 24px;
        margin: 32px 0 16px;
        font-weight: bold;
    }
`;